module.exports = __webpack_public_path__ + "static/media/DOPPLE-UST-LP.844ec60f.png";